import styled from 'styled-components'
import fonts from '../../tokens/fonts'
import { composeTheme } from '../../utils/compose-theme'

export const Container = styled.div.attrs((props) => composeTheme(props))`
  display: flex;
  flex-direction: row;
  position: static;

  > ol {
    display: flex;
    text-decoration: none;
    margin: 0;
    padding: 0;

    > li {
      display: flex;
      text-decoration: none;
      align-items: center;
    }

    li:nth-child(2) {
      a {
        margin-left: 1.2rem;
      }
    }

    li:last-child {
      a {
        color: ${(props) => props.theme.breadcrumbs.activeColor};
        padding: ${(props) => props.theme.breadcrumbs.activePadding};
        background-color: ${(props) =>
          props.theme.breadcrumbs.activeBackgroundColor};
        border-radius: ${(props) => props.theme.breadcrumbs.activeBorderRadius};
      }
    }
  }
`

export const Link = styled.a.attrs((props) => composeTheme(props))`
  color: ${(props) => props.theme.breadcrumbs.color};
  display: flex;
  text-decoration: none;
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.breadcrumbs.fontSize};
  font-weight: ${(props) => props.theme.breadcrumbs.fontWeight};
  margin-right: 0.8rem;
  margin-left: 0.8rem;
  padding: ${(props) => props.theme.breadcrumbs.padding};
  background-color: ${(props) => props.theme.breadcrumbs.backgroundColor};
  border-radius: ${(props) => props.theme.breadcrumbs.borderRadius};
`

export const ButtonIcon = styled.a.attrs((props) => composeTheme(props))`
  text-decoration: none;
  margin-right: 1.2rem;
  padding: ${(props) => props.theme.breadcrumbs.padding};
  background-color: ${(props) => props.theme.breadcrumbs.backgroundColor};
  border-radius: ${(props) => props.theme.breadcrumbs.borderRadius};

  svg {
    color: ${(props) => props.theme.breadcrumbs.color};
  }
`
